<template>
  <div
    class="td-cell_detail td-cell_light"
    colspan="100%"
  >
    <div
      class="d-flex w-100 f-wrap pa-6"
      style="grid-gap: 1rem"
      @click.stop
    >
      <div
        class="f-column"
        style="grid-gap: 0.75rem"
      >
        <div
          class="d-flex f-column gw_box"
          style="
            max-width: 24rem;
            --clr-box-back: var(--clr-black-2);
            --size-title: 0.875rem;
            --size-value: 1rem;
            gap: 0.75rem;
            word-break: break-all;
          "
        >
          <div>
            <div class="clr-grey weight_500 text-semi-larges">
              {{ $t('table_head.created_at') }}
            </div>
            <div class="weight_500">
              {{ formatISODate(item.created_at) }}
            </div>
          </div>
          <div>
            <div class="clr-grey weight_500 text-semi-larges">
              {{ $t('table_head.format') }}
            </div>
            <div class="weight_500">
              {{ item.gameformat ? $t(`gametypes.groups.${item.gameformat.group}`) : '' }}
            </div>
          </div>
          <div>
            <div class="clr-grey weight_500 text-semi-larges">
              {{ $t('table_head.name') }}
            </div>
            <div class="weight_500 text-wrap">
              {{ item.local_name }}
            </div>
          </div>
        </div>
        <div
          class="d-flex"
          style="grid-gap: 0.5rem"
          @click.stop
        >
          <component
            :is="item.component || 'div'"
            v-for="item in controls"
            :key="item.id"
            class="gw_btn-v1 clr-white gw_btn_text"
            v-bind="item.getProps({ row: item })"
            @click="
              item.fn({
                row: item,
                index: item.index,
                edit: 'edit',
                item,
              })
            "
          >
            <i
              class="mdi text-semi-large mr-2"
              :class="item.icon"
            ></i>
            {{ item.name }}
          </component>
        </div>
      </div>
      <div
        class="f-column"
        style="grid-gap: 0.5rem"
      >
        <PracticeStatsMainInfo
          :items="dataDetail.stats"
          class="gw_box"
          style="
            --clr-box-back: var(--clr-black-2);
            --size-title: 0.875rem;
            --size-value: 1rem;
            --gap: 1rem;
          "
        />
        <PracticeStatMovesChart
          class="gw_box"
          style="--clr-box-back: var(--clr-black-2)"
          :items="dataDetail.moves"
        />
      </div>
      <div
        class="f-column"
        style="grid-gap: 1rem"
      >
        <div
          class="f-column"
          style="grid-gap: 0.5rem"
        >
          <PracticeStatsSecondaryInfo :items="dataDetail.mistakes" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import PracticeStatsMainInfo from '@/components/PracticeHandsTotals/PracticeStatsMainInfo'
import PracticeStatsSecondaryInfo from '@/components/PracticeHandsTotals/PracticeStatsSecondaryInfo'
import PracticeStatMovesChart from '@/components/PracticeHandsTotals/PracticeStatMovesChart'
import GwMenu from '@/components/lib/GwMenu'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'

import { getPercentageOfMax } from '@/helpers/helpers'
import { getCorrectnessActionGroups } from '@/helpers/constants'
import { getTrainerScoreGroup } from '@/helpers/trainer'

export default {
  name: 'PracticeSessionsTableV2RowDetail',
  components: {
    TableBodyRow,
    TableBodyCell,
    Checkbox,
    PracticeStatsMainInfo,
    PracticeStatsSecondaryInfo,
    PracticeStatMovesChart,
    GwMenu,
  },
  mixins: [table_mix],
  props: {
    item: Object,
  },
  data() {
    return {}
  },
  methods: {
    playSession(row, force = false) {
      if (!force && !this.$store.getters.hands_configure) {
        const dialog = `trainer-restore-hand-dialog_action-playtablesession`
        this.$store.dispatch('router_set_dialogs', dialog)
        return
      }

      const alpha = 'tra/alpha'
      this.$store.dispatch('hands_stop', { configure: true })
      this.$store.dispatch(`${alpha}/router_update_query`, {
        query: row.fullQuery,
        push: false,
        replace: false,
        saveLocally: false,
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: alpha,
        to_namespace: alpha,
        queryGroup: 'router-to-gmf-selektor',
      })
      this.$router.push({
        name: 'PracticeTrainer',
        query: row.fullQuery,
      })
    },
  },
  computed: {
    controls() {
      const res = [
        {
          id: 'show_hands',
          icon: 'mdi-cards-playing',
          component: 'router-link',
          getProps: ({ row }) => ({
            to: {
              name: 'PracticeHands',
              query: {
                ffph_session: this.item.id,
                session_name: this.item.local_name,
              },
            },
          }),
        },
        {
          is_hidden: !this.item.gameformat,
          id: 'play_session',
          icon: 'mdi-play',
          fn: () => this.playSession(this.item),
        },
      ]
        .filter(i => !i.is_hidden)
        .map(i => {
          const r = {
            ...i,
            name: this.$t(`btn.${i.id}`),
            fn: i.fn || function () {},
            getProps:
              i.getProps ||
              function () {
                return {}
              },
          }
          return r
        })
      return res
    },
    dataDetail() {
      const data = this.item
      if (!data) return null

      const groups = getCorrectnessActionGroups()

      let moves = [
        {
          name: this.$t(`practice.stats.bests`),
          id: 'best_moves_sum',
          group: groups.best_move,
        },
        {
          name: this.$t(`practice.stats.corrects`),
          id: 'correct_moves_sum',
          group: groups.correct_move,
        },
        {
          name: this.$t(`practice.stats.inaccuracy`),
          id: 'inaccuracy_moves_sum',
          group: groups.inaccuracy,
        },
        {
          name: this.$t(`practice.stats.wrongs`),
          id: 'wrong_moves_sum',
          group: groups.wrong_move,
        },
        {
          name: this.$t(`practice.stats.blunders`),
          id: 'blunder_moves_sum',
          group: groups.blunder,
        },
      ]

      const movesValues = moves.map(dd => data[dd.id])
      const max = Math.max(...movesValues)

      moves = moves.map(i => {
        const r = {
          ...i,
          value: this.numKtoM(data[i.id] || 0, 1000, 1),
          value_percent_scaled: getPercentageOfMax({
            max,
            value: data[i.id],
          }),
        }
        return r
      })
      // console.log(moves)

      const gto_score = {
        id: 'gto_score_avg',
        unit: '',
        value: this.numFixed((data.gto_score_avg || 0) * 100),
        group: getTrainerScoreGroup(data.gto_score_avg),
      }

      const stats = [
        {
          name: this.$t('common.hands'),
          value: this.numKtoM(data.total_hands || 0, 10000, 2),
        },
        {
          name: this.$t('common.moves'),
          value: this.numKtoM(data.played_moves_sum || 0, 10000, 2),
        },
        {
          name: this.$t('common.mistakes'),
          value: this.numKtoM(data.mistake_moves_sum || 0, 10000, 2),
        },
        {
          name: this.$t('common.gto_score'),
          value: gto_score.value || 0,
          unit: '%',
        },
      ]

      let mistakes = [
        {
          id: 'total_ev_loss',
          rows: [
            {
              id: 'total_ev_loss_sum',
              unit: this.$t('common.bb'),
              decimal: 1,
            },
          ],
        },
        {
          id: 'average_ev_loss',
          rows: [
            {
              id: 'total_ev_loss_avg',
              unit: this.$t('common.bb_hand'),
              decimal: 2,
            },
            {
              id: 'total_ev_loss_as_pot_avg',
              unit: this.$t('common.pot_hand'),
              decimal: 2,
              times: 100,
            },
          ],
        },
        {
          id: 'average_mistake_ev_loss',
          rows: [
            {
              id: 'total_ev_loss_mistake_avg',
              unit: this.$t('common.bb_mistake'),
              decimal: 2,
            },
            {
              id: 'total_ev_loss_as_pot_mistake_avg',
              unit: this.$t('common.pot_mistake'),
              decimal: 2,
              times: 100,
            },
          ],
        },
        {
          id: 'total_frequency_difference',
          rows: [
            {
              id: 'total_frequency_difference_avg',
              unit: this.$t('common.percent_hand'),
              decimal: 0,
              times: 100,
            },
          ],
        },
      ]

      mistakes = mistakes.map(dd => {
        const rr = {
          ...dd,
          name: this.$t(`practice.stats.${dd.id}`),
          tooltip: this.$t(`tooltips.${dd.id}`),
          rows: dd.rows.map(ii => {
            const rrr = {
              ...ii,
              value: this.numFixed((data[ii.id] || 0) * (ii.times || 1), ii.decimal),
            }
            return rrr
          }),
        }
        return rr
      })

      const res = {
        stats,
        moves,
        mistakes,
      }
      // console.log(res)
      return res
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
  },
  watch: {
    globals_action(a) {
      if (a === 'playtablesession_apply') {
        this.playSession(this.item, 'force')
        this.$store.dispatch('globals_action_reset')
      }
    },
  },
}
</script>
